// Constants
export const STREAM_SEARCH_CHAT_ID = 'stream-search-chat';
export const STREAM_SEARCH_CHAT_ID_B = 'stream-search-chat-b';
export const COOKIE_KEY_MESSAGES = 'messages';
export const COOKIE_SEARCH_MAP = 'searchMap';
export const COOKIE_EXPIRATION_IN_DAYS = 1 / 288; // 5 minutes
